export default __webpack_public_path__ + "static/media/icons-trophy.b6ccca5d.png";